import { z, ZodType } from 'zod';

export type Paginated<T> = {
	total: number;
	rows: T[];
};

export const createPaginatedSchema = <T>(scheme: ZodType<T>): ZodType<Paginated<T>> =>
	z.object({
		total: z.number(),
		rows: z.array(scheme),
	});
